import {
  PluginEquifaxPpsrRegistrationForm,
  PluginEquifaxPpsrRegistrationFormResponse,
} from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runEquifaxPpsrRegistrationForm = (
  constructPost: ConstructPost,
  data: PluginEquifaxPpsrRegistrationForm,
): Promise<
  NonPaginatedResponse<PluginEquifaxPpsrRegistrationFormResponse> | undefined
> =>
  constructPost<
    NonPaginatedResponse<PluginEquifaxPpsrRegistrationFormResponse>
  >(`${PLUGIN_BASE_PATH}/equifax-ppsr-registration-form`, { data });
